const getUrlParameters = (href) => {
  const parameterStartChar = '?'
  const parametersSplitChar = '&'
  const parameterKeyValueSplitChar = '='

  const splitHref = href.split(parameterStartChar)

  // Check if url contains url parameters
  if (splitHref.length !== 2) return []

  const urlParameters = splitHref[1]

  // Check if theres at least one url parameter
  if (urlParameters.length === 0) return []

  return urlParameters
    .split(parametersSplitChar)
    .map(item => item.split(parameterKeyValueSplitChar))
}

module.exports = getUrlParameters
